<template>
  <div class="header-info">
    <!-- 左边 头像名称 -->
    <div class="img-name">
      <!-- 头像 -->
      <div class="img-box">
        <a-image
          class="img"
          :preview="false"
          :width="60"
          :height="60"
          :src="info?.photo || head_p"
          :fallback="head_p"
        />
        <template v-if="info.status !== null">
          <!-- 认证状态 0-未认证 1-已认证 -->
          <div v-if="info.status === 0" class="tag">未实名</div>
          <div v-else-if="info.status === 1" class="tag tag-check">已实名</div>
        </template>
      </div>
      <!-- 已注册 和 预注册 -->
      <div v-if="!!info.patientId || !!info.prePatientId" class="name-box">
        <div class="name">
          <PatientNameAgeReveal class="name-text" :name="info.name" :age="info.age" />
          <span class="sex">
            <template v-if="info.gender === 1">男</template>
            <template v-else-if="info.gender === 0">女</template>
            <template v-else>未知</template>
          </span>
          <span>{{ info.age || '--' }} 岁</span>
          <!--预建档才能显示 -->
          <edit-outlined v-if="info.prePatientId" class="edit-icon" @click="editUnverified" />
        </div>
        <div class="footer">患者ID: {{ info.ucPatientId || '--' }}</div>
        <div class="footer">
          使用权限：
          <span v-if="info.accountStatus === 0">正常</span>
          <span v-else-if="info.accountStatus === 1">异常</span>
          <span v-else>--</span>
        </div>
      </div>
      <!-- 未注册 -->
      <div v-else class="Unverified">
        未知用户
        <!-- <edit-outlined class="edit-icon" /> -->
      </div>
    </div>
    <!-- 右边 信息-->
    <div class="info-box">
      <div
        class="item"
        :class="{
          'large-item': item.label === '家庭住址' && !!info[item.key]
        }"
        v-for="item in headerInfo"
        :key="item.key"
      >
        <span class="label">{{ item.label }} :</span>
        <!-- 链接 -->
        <span class="text" :class="{ 'text-phone': item.key === 'phone' }">
          <!-- NOTE: 文案部分 -->
          <span
            v-if="['健康信息'].includes(item.label)"
            @click="info[item.key] && openDetail(item.key)"
            :class="{ 'text-link': info[item.key] }"
          >
            {{ ucPatientId ? '健康信息' : '--' }}
          </span>
          <span
            v-else-if="['身份证号'].includes(item.label)"
            :class="{ 'text-link': info[item.key] }"
            @click="info[item.key] && openDetail(item.key)"
          >
            {{ info[item.key] || '--' }}
          </span>
          <!-- 手机号有值才能显示 -->
          <span
            v-else-if="['注册号码'].includes(item.label)"
            @click="info[item.key] && openDetail(item.key)"
            :class="{ 'text-link': info[item.key] && (info.ucPatientId || info.prePatientId) }"
          >
            {{ `${info[item.key]} 关联手机号` || '--' }}
          </span>
          <ThePhoneRel
            v-else-if="['已关联号码'].includes(item.label)"
            :phoneRelList="info[item.key]"
            @onClick="info[item.key] && openDetail(item.key)"
          ></ThePhoneRel>
          <template v-else>
            {{ info[item.key] || '--' }}
          </template>
        </span>
      </div>
    </div>
    <!-- 右下角的标签（绝对定位） -->
    <div class="source">来源：{{ info.userSource || '暂无' }}</div>
    <!-- 手机号 -->
    <modal-phone ref="ModalPhoneDom"></modal-phone>
    <!-- 身份证 -->
    <a-modal
      ref="contentRef"
      :width="430"
      :footer="null"
      title="身份证号"
      v-model:visible="idCard.visible"
    >
      <div class="idModal">
        {{ idCard.num }}
      </div>
    </a-modal>
    <!-- 预注册 -->
    <modal-unverified ref="unverified" />
    <!-- 健康信息 -->
    <a-modal :footer="null" title="健康信息" :width="1000" v-model:visible="healthInfo.visible">
      <HealthInfo :ucUserId="ucPatientId" :canGoChat="false" />
    </a-modal>
  </div>
</template>

<script setup>
import HealthInfo from '@/views/HealthRecord/HealthInfo/index.vue'
import { useStore } from 'vuex'
import { headerInfo } from '../../config.js'
import head_p from '@/assets/img/chat/head_p.png'
import { computed, reactive, ref } from 'vue'
import { EditOutlined } from '@ant-design/icons-vue'
import { getID } from '@/api/patientFile.js'
import ModalPhone from './modalPhone.vue'
import ModalUnverified from './modalUnverified.vue'
import { message } from 'ant-design-vue'
import ThePhoneRel from './ThePhoneRel.vue'
import PatientNameAgeReveal from '@/components/PatientNameAgeReveal.vue'

const contentRef = ref()
const ModalPhoneDom = ref()
const store = useStore()
const info = computed(() => store.state.patientFile.info)

const ucPatientId = computed(() => store.state.patientFile.info.ucPatientId)

const idCard = reactive({
  visible: false,
  num: ''
})

const healthInfo = reactive({
  visible: false
})
// 打开详情
const openDetail = key => {
  const { prePatientId, patientId } = info.value
  const funMap = {
    phoneRelList() {
      this.phone()
    },
    // 打开手机号
    phone() {
      if (prePatientId || patientId) {
        ModalPhoneDom.value.open()
      } else {
        message.warn('患者未注册')
      }
    },
    // 打开身份证
    idCard() {
      if (patientId) {
        const params = { patientId }
        getID(params).then(result => {
          idCard.num = result
          idCard.visible = true
        })
      } else {
        message.warn('患者未实名')
      }
    },
    // 健康信息
    ucPatientId() {
      // 有患者id 才能打开
      healthInfo.visible = !!ucPatientId.value
    }
  }
  funMap[key]()
}

// 未实名
const unverified = ref()
// 编辑
const editUnverified = () => {
  unverified.value.openEdit()
}
</script>

<style lang="scss" scoped>
.header-info {
  background-color: white;
  padding: 16px 24px;
  display: flex;
  position: relative;
  border-radius: 4px 4px 0 0;
  .img-name {
    display: flex;
    min-width: 200px;
    flex-shrink: 0;
    .img-box {
      margin-right: 8px;
      position: relative;
      width: 60px;
      height: 60px;
      ::v-deep(.ant-image) {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        overflow: hidden;
      }
      .tag {
        color: #ff8f3f;
        background: #fef1e7;
        padding: 2px 8px;
        border-radius: 14px;
        font-size: 14px;
        border: 1px solid #ff8f3f;
        position: absolute;
        bottom: -4px;
      }
      .tag-check {
        color: #3f80ff;
        background: rgb(226, 234, 255);
        border: 1px solid #a0c0ff;
      }
    }
    .name-box {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      .sex {
        margin: 0 8px;
      }
      .footer {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
      }
    }
    .Unverified {
      cursor: pointer;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      display: flex;
      align-items: center;
    }
  }
  .info-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #d9e1e7;
    padding-left: 20px;
    margin-left: 20px;
    align-items: center;
    .item {
      font-size: 14px;
      width: 350px;
      height: 20px;
      padding-right: 10px;
      display: flex;
      margin-bottom: 4px;
      .label {
        width: 80px;
        color: #666666;
        margin-right: 8px;
        flex-shrink: 0;
        text-align: left;
      }
      .text {
        flex-grow: 1;
        color: #333333;
        .text-link {
          color: var(--el-color-primary);
          cursor: pointer;
        }
      }
      .text-phone {
        .phoneNum {
          vertical-align: text-bottom;
          cursor: pointer;
          margin-left: 4px;
        }
      }
    }
    .large-item {
      flex-grow: 1;
    }
  }
  .source {
    font-size: 14px;
    color: #9e9e9e;
    position: absolute;
    right: 0;
    top: 0;
    background: #fff5e9;
    color: #ff9412;
    padding: 4px 8px;
    border-radius: 0 4px 0 4px;
  }
}

.idModal {
  font-weight: 500;
  font-size: 20px;
  color: #000000d9;
}
</style>
